import { defineComponent as _defineComponent } from 'vue'
import { ImageEffectPreset } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import BodyPresetGridThumbnailHover from '@/components/DesignStudio/ImageEffectsProperties/components/create/components/body/preset/grid/thumbnail/hover/BodyPresetGridThumbnailHover.vue';
import CLazy from '@/components/CLazy.vue';
import { TippyComponent } from 'vue-tippy';
import CBadge from '@/components/shared/CBadge';

interface Props {
    preset: ImageEffectPreset;
    isSelected?: boolean;
    disabled?: boolean;
}

interface Emits {
    (event: 'select', preset: ImageEffectPreset): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BodyPresetGridThumbnail',
  props: {
    preset: null,
    isSelected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'select', preset: ImageEffectPreset): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { preset: ImageEffectPreset, isSelected: boolean, disabled: boolean };





const handleClick = () => {
    if (props.disabled) return;
    emit('select', props.preset);
};

return { __sfc: true,props, emit, handleClick, BodyPresetGridThumbnailHover, CLazy, TippyComponent, CBadge }
}

})